import { useEffect, useMemo, useState } from 'react';
import { ProjectBaseline } from 'api/project';
import { useProjectBaselineQuery } from 'queries/project-baseline-mutation';

export const useProjectBaselineByProjectId = (
  projectId: number,
): { data: ProjectBaseline[]; isLoading: boolean } => {
  const { data, isFetching } = useProjectBaselineQuery(projectId);

  return useMemo(() => {
    return { data: data ?? [], isLoading: isFetching };
  }, [data, isFetching]);
};

export const useActiveBaselinesByProjectId = (
  projectId: number,
): ProjectBaseline[] => {
  const { data: baselines } = useProjectBaselineByProjectId(projectId);

  const [activeBaselines, setActiveBaselines] = useState<ProjectBaseline[]>([]);

  useEffect(() => {
    setActiveBaselines(
      baselines.filter((_baseline) => _baseline.deleted !== true),
    );
  }, [baselines]);

  return activeBaselines;
};
